import { useState } from 'react';
import { Box, Button, Typography, Alert, Link } from '@mui/joy';
import api from '../../../lib/api';

type Audit = { issue_count: number; pages: Array<{ slug: string; issues: string[]; suggestions: Array<{url: string; title: string}> }> };
type Indexing = { status: string; message?: string; verdict?: string; coverage?: string; last_crawl?: string; google_canonical?: string };

export default function SeoAuditPanel({ projectId, pageId, slug }: {projectId: string; pageId: string | number; slug: string}) {
  const [audit, setAudit] = useState<Audit | null>(null);
  const [indexing, setIndexing] = useState<Indexing | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const run = async (kind: 'audit' | 'indexing') => {
    setBusy(true); setError('');
    try {
      if (kind === 'audit') setAudit((await api.get<Audit>(`/api/website-builder/projects/${projectId}/seo-audit/`)).data);
      else setIndexing((await api.post<Indexing>(`/api/website-builder/projects/${projectId}/pages/${pageId}/indexing/`, {})).data);
    } catch { setError('The check could not finish. Please try again.'); }
    finally { setBusy(false); }
  };
  const page = audit?.pages.find(p => p.slug === slug);
  return <Box>
    <Typography level="title-md">SEO checks</Typography>
    <Typography level="body-sm">Checks use saved page content. Save your edits first.</Typography>
    <Box sx={{ display: 'flex', gap: 1, my: 1 }}><Button loading={busy} onClick={() => run('audit')}>Audit saved pages</Button><Button disabled={busy} variant="outlined" onClick={() => run('indexing')}>Check Google indexing</Button></Box>
    {error && <Alert color="danger">{error}</Alert>}
    {audit && <Typography level="body-sm">{audit.issue_count} issues across the site.</Typography>}
    {page && <><ul>{page.issues.map(issue => <li key={issue}>{issue}</li>)}</ul>{!page.issues.length && <Typography>No issues found on this page.</Typography>}<Typography level="title-sm">Suggested contextual links</Typography><ul>{page.suggestions.map(s => <li key={s.url}>{s.title}: <code>{s.url}</code></li>)}</ul></>}
    {indexing && <Alert color={indexing.status === 'checked' ? 'neutral' : 'warning'}>{indexing.message || `${indexing.verdict || 'Unknown'}: ${indexing.coverage || 'No coverage detail'}. Last crawl: ${indexing.last_crawl || 'Not reported'}. Google canonical: ${indexing.google_canonical || 'Not reported'}.`}</Alert>}
    <Link href="https://search.google.com/search-console" target="_blank" rel="noopener noreferrer">Open Search Console</Link>
  </Box>;
}
